// extracted by mini-css-extract-plugin
export default {"pageDescription":"YfcuYcuUYZqngDsbINQP","title":"a9bv4b0mnBD1qeaHHyr5","text":"Ci_k2Fn8ZxG75iukVQfp"};